export const decimalFormatting = {
  namespaced: true,
  state: {
    decimalFormatReference: [
      {
        Name: "Decimal-6-4",
        Width: 150,
        ReadOnlyFormat: "#0.0000",
        EditFormat: "#0.0000",
      },
      {
        Name: "Decimal-0-0",
        Width: 150,
        ReadOnlyFormat: "#0",
        EditFormat: "#0",
      },
      {
        Name: "Decimal-16-0",
        Width: 150,
        ReadOnlyFormat: "##,###,###,###,##0",
        EditFormat: "##,###,###,###,##0",
      },
      {
        Name: "Decimal-16-2",
        Width: 105,
        ReadOnlyFormat: "##,###,###,###,##0.00;(##,###,###,###,##0.00)",
        EditFormat: "##,###,###,###,##0.00",
      },

      {
        Name: "Decimal-16-2C",
        Width: 150,
        ReadOnlyFormat: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
        EditFormat: "$ ##,###,###,###,##0.00",
      },
      {
        Name: "Decimal-16-2P",
        Width: 150,
        ReadOnlyFormat: "##,###,###,###,##0.00 '%';(##,###,###,###,##0.00 '%')",
        EditFormat: "##,###,###,###,##0.00 '%'",
      },
      {
        Name: "Decimal-3-2P",
        Width: 80,
        ReadOnlyFormat: "##0.00 '%';(##0.00 '%')",
        EditFormat: "##0.00 '%'",
      },
      {
        Name: "Decimal-16-4",
        Width: 150,
        ReadOnlyFormat: "##,###,###,###,##0.0000",
        EditFormat: "##,###,###,###,##0.0000",
      },
      {
        Name: "Decimal-16-4C",
        Width: 150,
        ReadOnlyFormat: "$ ##,###,###,###,##0.0000;($ ##,###,###,###,##0.0000)",
        EditFormat: "$ ##,###,###,###,##0.0000",
      },
      {
        Name: "Decimal-3-2",
        Width: 80,
        ReadOnlyFormat: "##0.00;(##0.00)",
        EditFormat: "##0.00",
      },
    ],
  },
  actions: {},
  mutations: {},
  getters: {
    getDecimalFormats(state) {
      return state.decimalFormatReference;
    },
    getDecimalFormatByCode: (state) => (Code) => {
      return state.decimalFormatReference.find((i) => i.Code == Code);
    },
    getDecimalFormatByName: (state) => (Name) => {
      return state.decimalFormatReference.find((i) => i.Name == Name);
    },
  },
};
